export default __webpack_public_path__ + "static/media/RegularUser.0b5f5856.svg";